import { PageId } from 'page-constants'

import { useIsCurrentRoute } from './useIsCurrentRoute'
import { usePurchaseCancelOfferRoute } from './usePurchaseCancelOfferRoute'

export const useIsCancelOfferRoute = () => {
  let cancelOfferRoute = usePurchaseCancelOfferRoute()
  const isCancelOfferQuestion = useIsCurrentRoute(PageId.CANCEL_OFFER_QUESTION)
  if (
    cancelOfferRoute === PageId.CANCEL_OFFER_QUESTION &&
    !isCancelOfferQuestion
  ) {
    cancelOfferRoute = PageId.SPECIAL_PURCHASE_CANCEL_OFFER
  }
  return useIsCurrentRoute(cancelOfferRoute)
}
